import { Logout } from 'react-admin';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const LogoutButton = props => <Logout {...props} icon={<ExitToAppIcon/>} />;

export default LogoutButton;